<script lang="ts">
  import { page } from '$app/stores'
  import Signup from '$lib/components/Signup.svelte'
  import { Alert, Avatar, Button, Stepper } from '@bruce/components'
  import type { PageData } from './$types'
  import { SIGNUP_STRINGS } from './strings'
  import { STRINGS } from '$lib/constants/strings'
  import { utils } from '$lib/utils'

  export let data: PageData
  $: ({ lang, currentCity, owner, imageUrl } = data)
  $: localeRoute = utils.getRoute(lang)
  $: error = $page.url.searchParams.get('error') ?? ''
  $: trial = $page.url.searchParams.has('trial')
  $: tier = $page.url.searchParams.has('tier')
  $: credits = $page.url.searchParams.has('credits')
  $: giftCard = $page.url.searchParams.has('gift-card')
  $: inviteCode =
    $page.url.searchParams.get('inviteCode') ?? // Camel case due to legacy compability (a link is sent from the app)
    $page.url.searchParams.get('invite-code') ??
    undefined
</script>

<div class="container">
  {#if inviteCode && owner}
    <div class="invite-banner">
      <Avatar
        src={owner.photo ? `${imageUrl}/${owner.photo}` : undefined}
        alt={owner.first_name}
        size={6}
      />
      <p>
        {owner.first_name}
        {SIGNUP_STRINGS[lang].INVITATION[0]}
        <span class="code">{inviteCode}</span>
        {SIGNUP_STRINGS[lang].INVITATION[1]}
      </p>
    </div>
  {:else if tier && !trial && !giftCard}
    <Stepper
      block
      steps={[
        {
          label: STRINGS[lang].MEMBERSHIP_STEPPER_SELECT_MEMBERSHIP,
          completed: true,
        },
        {
          label: STRINGS[lang].MEMBERSHIP_STEPPER_SIGNUP,
          completed: false,
        },
        {
          label: STRINGS[lang].MEMBERSHIP_STEPPER_PAYMENT,
          completed: false,
        },
      ]}
    />
  {:else if trial || tier || credits || giftCard}
    <div>{SIGNUP_STRINGS[lang].STEP}</div>
  {/if}
  <h2>{SIGNUP_STRINGS[lang].TITLE}</h2>
  {#if giftCard}
    <p class="gift-card-text">{SIGNUP_STRINGS[lang].GIFT_CARD_TEXT}</p>
  {/if}
</div>
{#if error}
  <div class="error">
    <Alert icon="ph-warning">
      <div class="alert">
        <div>{STRINGS[lang].ERROR_SOMETHING_WENT_WRONG}</div>
        <code>{error}</code>
      </div>
    </Alert>
    <div class="button">
      <Button
        rounded
        variant="outlined"
        prependIcon="ph-arrow-clockwise"
        href={localeRoute('/signup')}
      >
        {STRINGS[lang].ERROR_TRY_AGAIN}
      </Button>
    </div>
  </div>
{:else}
  <Signup cityId={owner?.city_id || currentCity?.id || 1} {inviteCode} />
{/if}

<style lang="scss">
  @use '@bruce/assets/css/breakpoints';

  .container {
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-top: 1em;

    h2 {
      text-align: left;
      margin: 0;
    }

    .invite-banner {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      gap: 2em;
      max-width: 480px;
      background-color: var(--color-tertiary);
      color: var(--color-on-tertiary);
      padding: 1em;
      border-radius: 1em;
      margin-bottom: 1em;

      p {
        text-align: left;

        .code {
          font-weight: bold;
        }
      }
    }

    .gift-card-text {
      text-align: left;
    }
  }

  .error {
    display: flex;
    flex-direction: column;
    margin-top: 1em;
    gap: 1em;

    .alert {
      display: flex;
      flex-direction: column;
      gap: 1em;
      flex: 1;
      margin: 1em 0;
    }

    .button {
      align-self: center;
    }
  }
</style>
